<template>
    <tbody>
        <tr v-for="(file, i) in fileLists" v-bind:key="i" class="tableRow">
            <file-item v-bind:file="file"
                       v-on:onListDelete="propsDelete"
            >
            </file-item>
        </tr>
    </tbody>
</template>

<script>
    import FileItem from "./fileItem";
    export default {
        name: "fileList",
        components: {FileItem},
        props: ['fileLists'],
        methods: {
            propsDelete: function(fileName) {
                // log("delete list: ", fileName)
                this.$emit('onDelete', fileName)
            },
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/fileList.vue